import { api } from '@/lib/api/client';
import type { ClubAdminClaimRequest, ClubAnalyticsResponse, ClubCompetitionEntry } from '@shared/types/entities';

export {
  getClubsApi,
  getClubApi,
  createMembershipRequestApi,
  getMyMembershipRequestApi,
  sendClubMessageApi,
} from '@api-client/clubs';
export type { Club, ClubMembershipRequest, GetClubsParams } from '@api-client/clubs';
export type { ClubAnalyticsResponse } from '@shared/types/entities';

// ─── Club Competitions (public) ───────────────────────────────────

export async function getClubCompetitionsApi(clubId: number): Promise<ClubCompetitionEntry[]> {
  return api.get(`/clubs/${clubId}/competitions`);
}

// ─── Club Analytics ───────────────────────────────────────────────

export async function getClubAnalyticsApi(clubId: number): Promise<ClubAnalyticsResponse> {
  return api.get(`/clubs/${clubId}/analytics`);
}

// ─── Club Admin Claim ──────────────────────────────────────────────────────

export async function getPendingClaimApi(clubId: number): Promise<ClubAdminClaimRequest | null> {
  return api.get(`/clubs/${clubId}/claim/pending`);
}

export async function createClaimApi(clubId: number): Promise<ClubAdminClaimRequest> {
  return api.post(`/clubs/${clubId}/claim`);
}

export async function voteClaimApi(clubId: number, claimId: number): Promise<ClubAdminClaimRequest> {
  return api.post(`/clubs/${clubId}/claim/${claimId}/vote`);
}

export interface MyPendingClaim {
  id: number;
  clubId: number;
  status: string;
  club: { id: number; name: string; city: string };
}

export async function getMyPendingClaimApi(): Promise<MyPendingClaim | null> {
  return api.get('/clubs/claims/my-pending');
}
